export interface IAnwswer{
    ansCode:number,
    text:string
}

export interface IImage {
    exist:boolean,
    src?:string
}

export type TArrayAnswer = IAnwswer[];

export interface IQuestion {
    theme:string,
    question:string,
    image:IImage
    answer:TArrayAnswer,
    correct:number
}

export type TArrayQuestion = IQuestion[]

export interface IQuestionObj {
    pt?:TArrayQuestion,
    fr?:TArrayQuestion,
    sp?:TArrayQuestion,
    en?:TArrayQuestion
}

export enum EStatusEndQuiz {
    gameOver,
    noQuestion,
    timeEnd
}

export interface IRecordObj {
    status:boolean,
    points:number,
    place?:number
}

export interface IRecordItem {
    user:string,
    date:Date,
    score:number
}

export type TRecordCollection = IRecordItem[]